import type { IslandTheme } from "@tiny-seas/shared";
import { PALETTE } from "./materials.ts";
import type { SurfaceTextureId } from "./surface-textures.ts";

type TerrainTextureId = Extract<SurfaceTextureId, "sand" | "ground" | "rock" | "snow">;

interface TerrainTheme {
  sand: string;
  wetSand: string;
  grass: string;
  grassDark: string;
  rock: string;
  /** Shore, inland and exposed cliff layers; images are shared across themes. */
  maps: readonly [TerrainTextureId, TerrainTextureId, TerrainTextureId];
  tufts: boolean;
}

export const TERRAIN: Record<IslandTheme, TerrainTheme> = {
  tropical: { sand: PALETTE.sand, wetSand: PALETTE.wetSand, grass: PALETTE.grass, grassDark: PALETTE.grassDark, rock: PALETTE.rock, maps: ["sand", "ground", "rock"], tufts: true },
  volcanic: { sand: "#3b3633", wetSand: "#2a2624", grass: "#6b5a4a", grassDark: "#4a3f37", rock: "#2e2b2a", maps: ["sand", "rock", "rock"], tufts: false },
  frost: { sand: "#d9dde0", wetSand: "#a9b3b8", grass: "#eef3f6", grassDark: "#cfd9df", rock: "#7d8a93", maps: ["snow", "snow", "rock"], tufts: false },
  marsh: { sand: "#8a7d55", wetSand: "#5f5638", grass: "#5d7a3a", grassDark: "#3f5a2c", rock: "#5e5f52", maps: ["sand", "ground", "rock"], tufts: true },
  ruins: { sand: "#e2c99a", wetSand: "#bfa676", grass: "#9aa65a", grassDark: "#7a8646", rock: "#b8ab94", maps: ["sand", "ground", "rock"], tufts: true },
};
